export default __webpack_public_path__ + "static/media/about2.0a4d921e.jpg";